export default {
    key: 'first-flyer',
    type: 'Activity',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: true,
    hideCrossSells: false,
    disablePassengers: false,
    activityId: 'f37df69d-66c9-437b-8d93-2ff9cdd2a819',
    categoryId: undefined,
    defaultDuration: 1440,
    isMultiDay: false,
    isUsingReductionCards: false,
    isUsingKeyCards: false,
    isUsingPromos: true,
    showDuration: false,
    upsells: [],
    salesTimeLimit: 660, // 11:00
    isUpsellDatesRestricted: false,
    maxNumberOfPeople: 10,
    maxNumberOfPeopleGroupTariff: undefined,
    isUsingSeasonDates: false,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: 'f37df69d-66c9-437b-8d93-2ff9cdd2a819',
    isLocalListing: true,
    steps: [
        {
            routeName: 'offerFlow-first-flyer-steps-step-1-date',
            name: 'offerFlow.pages.stepDate.name.common',
        },
        {
            routeName: 'offerFlow-first-flyer-steps-step-2-passengers',
            name: 'offerFlow.pages.stepPassengers.name.common',
            skipIfUpsell: true,
        },
    ],
} satisfies ProductConfigActivity;
